import styled from 'styled-components'
import theme from 'src/styles/theme'
import TextFieldMui from 'src/components/TextFieldMui'

export const Container = styled.div`
  padding: 0rem 2rem 2rem;
  .page-body {
    background-color: #F5F5F5 !important;
  }
`
export const InfoContainer = styled.div`
  margin-top: 0.5rem;
  border-radius: 0px 8px 8px 0px;
  border-left: ${`3px solid ${theme.colors.blue}`};
  padding: 8px 16px 8px 8px;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  background-color: ${theme.colors.white};
  width: 100%;
  border-top: ${`1px solid ${theme.colors.gray4}`};
  border-bottom: ${`1px solid ${theme.colors.gray4}`};
  border-right: ${`1px solid ${theme.colors.gray4}`};
`

export const SubTitle = {
  marginBottom: 0,
  fontSize: '1.5rem',
  fontWeight: 700,
  fontFamily: 'Work Sans',
}

export const FieldValue = styled.span`
    font-size: 14px;
    font-family: Work Sans;
    margin-left: 0.4rem;
    font-weight: 400;
`

export const Field = styled(FieldValue)`
  font-weight: bold;
`

export const FormContainer = styled.div`
  margin: 0 0 16px;
`

export const ButtonContainer = styled.div``

export const TextAlert = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: ${theme.colors.red};
`

export const CustomTextField = styled(TextFieldMui)<{ minWidth?: string }>`
  margin: 0 !important;
  min-width: ${({ minWidth }) => (minWidth || '10rem')} !important;
`

export const DriverContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 1rem;
`
